import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MentoringDocumentModel } from 'common/models/page-models/mentoring-document/mentoring-document-data.model';
import { MentoringDocumentListingModel } from 'common/models/page-models/mentoring-document/mentoring-document-grid.model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { MentoringGridWidgetService } from 'common/widget/mentoring-doc/mentoring-grid.widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class MentoringDocumentGridResolver extends GridResolver<MentoringDocumentModel, MentoringDocumentListingModel> {
    constructor(
        protected fs: MentoringGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}